var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26695(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26695",
    "data-name": "Group 26695",
    transform: "translate(-700 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(700 788)",
    fill: "#1e8d3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23253",
    "data-name": "Path 23253",
    d: "M552.1,72.712V98.507a3.517,3.517,0,0,1-3.517,3.517H518.1a3.5,3.5,0,0,1-3.452-3.517V72.712a3.5,3.5,0,0,1,3.452-3.517h30.484a3.477,3.477,0,0,1,3.517,3.517m-29.378,1.759a.586.586,0,0,0-.586-.586h-3.451a.586.586,0,0,0-.586.586v3.517a.586.586,0,0,0,.586.586H522.2a.586.586,0,0,0,.586-.586Zm0,12.9V83.851a.586.586,0,0,0-.586-.586h-3.451a.586.586,0,0,0-.586.586v3.517a.586.586,0,0,0,.586.586H522.2a.586.586,0,0,0,.586-.586Zm0,5.862a.586.586,0,0,0-.586-.586h-3.451a.586.586,0,0,0-.586.586v3.517a.586.586,0,0,0,.586.586H522.2a.586.586,0,0,0,.586-.586Zm17.654-18.173a1.173,1.173,0,0,0-1.172-1.172H527.478a1.172,1.172,0,0,0-1.172,1.172v7.035a1.172,1.172,0,0,0,1.172,1.172H539.2a1.173,1.173,0,0,0,1.172-1.172Zm0,14.07a1.173,1.173,0,0,0-1.172-1.172H527.478a1.172,1.172,0,0,0-1.172,1.172v7.035a1.172,1.172,0,0,0,1.172,1.172H539.2a1.173,1.173,0,0,0,1.172-1.172Zm8.141-11.139V74.471a.586.586,0,0,0-.586-.586h-3.451a.577.577,0,0,0-.521.586v3.517a.586.586,0,0,0,.586.586H548a.586.586,0,0,0,.586-.586Zm.067,5.862a.587.587,0,0,0-.586-.586h-3.452a.586.586,0,0,0-.586.586v3.517a.586.586,0,0,0,.586.586H548a.586.586,0,0,0,.586-.586Zm.066,12.9V93.231a.586.586,0,0,0-.586-.586H544.61a.587.587,0,0,0-.586.586v3.517a.533.533,0,0,0,.521.586H548a.586.586,0,0,0,.586-.586Z",
    transform: "translate(202.354 738.805)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26695);
export default __webpack_public_path__ + "static/media/Group 26695.2e3987ebfc6b275307fe4b5991d2eb27.svg";
export { ForwardRef as ReactComponent };